export default __webpack_public_path__ + "static/media/navigator.6199efd5.svg";